import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Col, Container, Row} from "reactstrap";
import {Link} from "react-router-dom";
import UserPanelMenu from "../../components/user/UserPanelMenu";


class UsersPage extends Component {

    render() {
        return (
            <div className="pt-5 mt-5">
                <Container>
                    <Breadcrumb className='w-100 white mt-3'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">User Control panel</Link></BreadcrumbItem>
                        <BreadcrumbItem active> Dashboard</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5'>
                        <Col md='3' sm='12' className="">
                            <div className="panel panel-default sidebar-menu white">



                                <div className="panel-body">

                                   <UserPanelMenu activeElement="1"/>
                                </div>

                            </div>
                        </Col>
                        <Col md='9' sm='12' >
                            <div className='white p-3'>
                                <h3>Welcome to user area</h3>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>
        );
    }
}


export default UsersPage;



// WEBPACK FOOTER //
// ./src/containers/user/UsersPage.js